import { isApp } from "@akina/utils";
import { memoryInfo, cpuInfo } from "tauri-plugin-system-info-api";

export type DeviceInfo = {
  totalRamGb: number;
  cpuCores: number;
  cpuFrequency: number;
};

const DEFAULT_DEVICE_INFO = {
  totalRamGb: 0,
  cpuCores: 0,
  cpuFrequency: 0,
};

export const getDeviceInfo = async (): Promise<[DeviceInfo, string]> => {
  if (isApp) {
    try {
      const { total_memory } = await memoryInfo();
      const { cpus } = await cpuInfo();
      const firstCpu = cpus[0];
      const totalRamGb = total_memory ? total_memory / 1024 ** 3 : 0;
      const deviceInfo = {
        totalRamGb,
        cpuCores: cpus.length,
        cpuFrequency: firstCpu.frequency,
      };
      return [deviceInfo, `RAM ${totalRamGb.toFixed(1)}GB - CPU ${firstCpu.brand ?? "unknown"} (${cpus.length} cores)`];
    } catch {
      return [DEFAULT_DEVICE_INFO, "unknown"];
    }
  } else {
    return [DEFAULT_DEVICE_INFO, "unknown"];
  }
};
